module.exports = __webpack_public_path__ + "img/Somalia.ff671481.gif";